import styled from 'styled-components';

export const Container = styled.div``;

export const Info = styled.main`
  max-width: 1120px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;

  place-content: center;

  align-items: center;
  justify-items: center;

  .header {
    width: 90vw;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 16px;
    h1 {
      color: #2c73e9;
      font-weight: 500;
    }
    button {
      background: #2c73e9;
      height: 36px;
      border-radius: 10px;
      border: 0;
      padding: 0 16px;
      color: #fff;
      font-size: 16px;
      font-weight: 500;
      display: flex;
      justify-content: center;
      align-items: center;
      transition: background-color 0.2s;
      &:hover {
        background: #2565cf;
      }

      svg {
        margin-right: 8px;
      }
    }
  }

  /* button {
    width: 250px;
  } */
`;

export const Tabela = styled.div`
  place-content: center;
  margin: 16px 8px;
  background-color: #fbfbfb;
  width: 90vw;

  .react-grid-Grid {
    margin-bottom: 8px;
    user-select: text;
  }

  .react-grid-Cell__value {
    padding: 8px 0px;
  }

  input {
    width: 100%;
    padding: 4px;
    border: 1px solid #bbb;
    border-radius: 8px;
  }

  button {
    border: 1px solid #2c73e9 !important;
    border-radius: 8px;
    color: #2c73e9 !important;
    font-size: 16px !important;
    font-weight: 500 !important;
    margin-bottom: 8px !important;
  }
`;
